import { api } from "../api";

/**
 * findAllCountriesListResponse - Function that finds on database all countries as select list   
 * /countries  
 * method GET 
 * @async-function
 */
const findAllCountriesListResponse = async (token: string) => {
    const response = await api.get(
        `/countries`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    );
    return response;
};
export default findAllCountriesListResponse;